import React from 'react';
import { Link, useTranslate } from 'react-admin';
import { makeStyles } from '@mui/styles';

import Login from './Login';
import LoginForm from './LoginForm';

const useStyles = makeStyles((theme) => ({
	link: {
		display: 'block',
		textAlign: 'center',
		textDecoration: 'underline',
		margin: theme.spacing(1)
	},
}));

const LoginPage = () => {
	const classes = useStyles();
	const translate = useTranslate();

	return (
		<Login>
			<LoginForm />
			<Link to="/forgot-password" className={classes.link}>{translate('Forgot password?')}</Link>
		</Login>
	);
};

export default LoginPage;
